import { dy, gateHeight, gateWidth } from '../components/pages/Circuit/constants';

const generateRangeArray = (start, end) => Array.from(
  { length: end - start + 1 },
  (_, index) => start + index,
);

const calculateMaxWidth = (layer) => Math.max(
  ...layer.map(({
    numControls,
    qubits,
  }) => {
    const targets = qubits.slice(numControls);
    const sortedQubits = [...targets].sort((a, b) => a - b);
    const containedLayers = generateRangeArray(
      sortedQubits[0],
      sortedQubits[sortedQubits.length - 1],
    );
    return containedLayers.length > 1
      ? Math.max(
        Math.ceil(((containedLayers.length - 1) * dy + gateHeight) / 2),
        gateWidth,
      )
      : gateWidth;
  }),
);

export {
  generateRangeArray,
  calculateMaxWidth,
};
